import { ModelMapper } from "@omni/types/utils/modelMapper";

import { AutocompleteAddress } from "@/services/bpost.service";

type LinkedField = { field: string; value: any };
type LinkedFields = Array<LinkedField>;

export const getLinkedFieldNames = (prefix = "") =>
    [
        "street",
        "number",
        "box",
        "zipCode",
        "city",
        "country",
        "isComplete",
        "selected"
    ].map((fieldName) => prefix + fieldName);

export const addressToLinkedFieldMapper: (
    prefix?: string
) => ModelMapper<AutocompleteAddress, LinkedFields> =
    (prefix = "") =>
    (address) => [
        {
            field: `${prefix}street`,
            value: address?.streetName || ""
        },
        {
            field: `${prefix}number`,
            value: address?.houseNumber || ""
        },
        {
            field: `${prefix}box`,
            value: address?.boxNumber || ""
        },
        {
            field: `${prefix}zipCode`,
            value: address?.postalCode || ""
        },
        {
            field: `${prefix}city`,
            value: address?.municipalityName || ""
        },
        {
            field: `${prefix}country`,
            value: "BE"
        },
        {
            field: `${prefix}isComplete`,
            value: !!address?.isComplete
        },
        {
            field: `${prefix}selected`,
            value: !!address
        }
    ];
